module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.agenda.acknowledge) ? _c('popover', {
    attrs: {
      "placement": "right",
      "width": "350",
      "trigger": "hover"
    }
  }, [_c('button', {
    staticClass: "btn btn-block blue-soft",
    attrs: {
      "slot": "reference",
      "type": "button"
    },
    slot: "reference"
  }, [_c('i', {
    staticClass: "fa fa-eye",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Visualizado por...")])]), _vm._v(" "), _c('ul', {
    staticClass: "list-group m-b-0"
  }, _vm._l((_vm.agenda.acknowledge), function(log) {
    return _c('li', {
      staticClass: "list-group-item"
    }, [_vm._v("\n\t\t\t" + _vm._s(log.responsible.name) + " (" + _vm._s(_vm._f("date")(log.acknowledgeDateTime, 'DD/MM/YYYY HH:mm')) + ")\n\t\t")])
  }))]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-98d41492","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./sources/domains/agenda/agenda-viewers/agenda-viewers.vue
// module id = 1097
// module chunks = 1